import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/build/repo/_repo')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'o5-repo-list',
        label: 'Repos',
        to: '/tech-ops/build/repo',
      }),
    }) satisfies AggregateBreadcrumb,
});
